(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var gallery = document.querySelector('[data-gallery]');
    var lightbox = document.querySelector('[data-lightbox]');
    if (!gallery || !lightbox) return;

    var slides = [].slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    if (!slides.length) return;

    var lbImage = lightbox.querySelector('[data-lightbox-image]');
    var lbCounter = lightbox.querySelector('[data-lightbox-counter]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var lbThumbs = [].slice.call(lightbox.querySelectorAll('[data-lightbox-thumb]'));
    var total = slides.length;
    var current = 0;

    function render() {
      var slide = slides[current];
      lbImage.src = slide.getAttribute('data-full');
      lbImage.alt = slide.getAttribute('data-alt') || '';
      if (lbCounter) lbCounter.textContent = current + 1 + ' / ' + total;
      lbThumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === current);
      });
    }

    function open(i) {
      current = (i + total) % total;
      render();
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
    }

    function close() {
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
    }

    function step(delta) {
      current = (current + delta + total) % total;
      render();
    }

    slides.forEach(function (s) {
      s.addEventListener('click', function () {
        open(parseInt(s.getAttribute('data-index'), 10));
      });
    });

    lbThumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        current = parseInt(t.getAttribute('data-index'), 10);
        render();
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Click on the backdrop (the dialog element itself) closes it.
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    // Arrow keys navigate while the lightbox is open.
    lightbox.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        step(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        step(1);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
